import { ActionTree } from 'vuex'
import { State } from './'

import { bus } from '@/main'

const actions: ActionTree<State, any> = {
	setCurrentScreen({ state, commit }, payload: number) {
		if (payload >= 0 && payload <= state.data.questions.length) {

			if (payload === state.data.questions.length && state.userOnResultScreen) {
				setTimeout(() => {
					window.scrollTo(0, 0)
				}, 330)
			}

			commit('userOnResultScreen', false)
			commit('setCurrentScreen', payload)
		} else if (payload >= 0 && payload === (state.data.questions.length + 1)) {
			commit('userOnResultScreen', true)
		}
	},
	onAnswerScreen({ state, commit }, payload: {onAnswerScreen: boolean, fromSameQuestion: boolean}) {
		bus.$emit('onAnswerScreenChange', payload.fromSameQuestion)

		commit('onAnswerScreen', payload.onAnswerScreen)
	},
	userOnResultScreen({ state, commit }, payload: boolean) {
		commit('userOnResultScreen', payload)
	},
	setUserChoices({ state, commit }, payload: any[]) {
		commit('setUserChoices', payload)
	},
	setRandomizedOptions({ state, commit }, payload: any[]) {
		commit('setRandomizedOptions', payload)
	},
	setFormInputValues({ state, commit }, payload: { questionId: number, answers: { [key: string]: string } }) {
		let formDataFound: boolean = false
		let fullFormInputValues = state.formInputValues

		;(<any>fullFormInputValues).forEach((formData: { questionId: number, answers: { [key: string]: string } }, index: number) => {
			if (formData.questionId === payload.questionId) {
				formDataFound = true
				;(<any>fullFormInputValues).splice(index, 1, payload)
			}
		})

		if (!formDataFound) {
			(<any>fullFormInputValues).push(payload)
		}

		commit('setFormInputValues', fullFormInputValues)
	},
	setQuestionVisited({ state, commit }, payload: number) {
		if (state.visitedQuestions.indexOf(payload) === -1) {
			commit('setQuestionVisited', payload)
		}
	}
}

export default actions
